import { lazy } from "react";
import i18n from "i18next";
import type { GameModule } from "../types";
import { MINE_FIELD_NS, registerMineFieldTranslations } from "./i18n";

registerMineFieldTranslations(i18n);

/** Minefield (ADR 0078). Keyed `mine_field`; the name people see comes from i18n. */
export const mineFieldModule: GameModule = {
  key: "mine_field",
  namespace: MINE_FIELD_NS,
  Player: lazy(() => import("./Player")),
};
